<template>
  <div class="btn_config_config chartConfig_viewDP">
    <div class="chartDivConfig checkViewConfig">
      <el-checkbox v-model="config.pop.show" @change="getRender">是否启动</el-checkbox>
    </div>
    <div class="chartDivConfig selViewConfig">
      <span class="span_til">联动图层</span>
      <ul class="tuceng">
        <li v-for="(item1,index) in config.pop.layer" :key="index">
          <el-select style="width: 200px;" v-model="config.pop.layer[index].name" placeholder="请选择跳转页" :popper-append-to-body="false" @change="getRender">
            <el-option style="width: 200px;" v-for="item in vuex.chartList" :key="item.id" :label="item.aliasName" :value="item.id">
            </el-option>
          </el-select>
          <div class="del" v-if="index!==0">
            <FSvg title="删除" color="#666" IconSize="22" @click.native="delMore(item1,index)"></FSvg>
          </div>
        </li>
      </ul>
      <div class="add">
        <FSvg title="加" color="#666" IconSize="22" @click.native="addMore()"></FSvg>
      </div>

    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/24 8:04 下午
 */
export default {
  name: 'push_config',
  components: {},
  data() {
    return {
      moreList: [],
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
  },
  computed: {
    vuex() {
      return this.$store.state.designer;
    },
    config() {
      if (this.type === 'view') {
        return this.$store.state.viewDP.chart.setting.params;
      } else if (this.type === 'screen') {
        return this.$store.state.designer.chart.setting.params;
      }
    },
    chartList() {
      if (this.type === 'screen') {
        let grpList = this.$store.state.designer.chartList;
        grpList.push({
          "id": null,
          "screenPageName": '空',
        })
        return grpList
      }
    },
  },
  methods: {
    getRender() {
      if (this.type === 'view') {
        this.$store.dispatch('viewDPRender');
      } else if (this.type === 'screen') {
        this.$store.dispatch('screenRender');
      }
    },
    addMore() {
      this.config.pop.layer.push({ name: '空' })
    },
    delMore(item1, index) {
      this.config.pop.layer.splice(index, 1);
    }
  },

  mounted() {
  },
  destroyed() {

  }

}
</script>

<style lang="less">
.btn_config_config {
}
.add {
  width: 100%;
  float: left;
  padding: 0 0 0 30px;
}
li{
  margin-bottom: 10px;
}
.del {
  float: right;
  margin: 0 0 0 10px;
}
.tuceng {
  float: left;
  margin-left: 30px;
}
</style>
